export default __webpack_public_path__ + "static/media/TezosIndia.135f342b.svg";